<ifc-identity-verification-result-content
  [title]="title"
  [message]="message"
  [messageHtml]="messageHtml"
  (closePage)="onClosePage()"
></ifc-identity-verification-result-content>
